module.exports = function (Vue, config) {
  Vue.mixin({
    created: function () {
      this.$config = config
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-config/index.js
// module id = +5wz
// module chunks = 0